module.exports = __webpack_public_path__ + "img/gb-eng.365ea776.svg";